import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService, AuthService } from 'src/app/@core/services';
import { ThemeHelpersService } from '../../helpers';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: [
    ]
})
export class HeaderComponent implements OnInit {
    constructor(
        private themeHelper: ThemeHelpersService,
        private authService: AuthService,
        private appConfig: AppConfigService,
        private route: Router,
    ) {}

    ngOnInit(): void {}
}
